import { render, staticRenderFns } from "./buysms.vue?vue&type=template&id=03a8e9a0&scoped=true&"
import script from "./buysms.vue?vue&type=script&lang=js&"
export * from "./buysms.vue?vue&type=script&lang=js&"
import style0 from "./buysms.vue?vue&type=style&index=0&id=03a8e9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8e9a0",
  null
  
)

export default component.exports